const AISection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">🤖 Trợ Lý AI</h2>
            <p className="text-slate-700">
                Trợ lý AI thông minh hỗ trợ học tập 24/7 với công nghệ GPT-4.
            </p>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Cách sử dụng:</h3>
                <ol className="list-decimal list-inside space-y-3 text-slate-700">
                    <li>Nhấn vào menu <strong>"Trợ lý AI"</strong> trên thanh điều hướng</li>
                    <li>Chọn loại bài toán hoặc chủ đề cần hỗ trợ</li>
                    <li>Chọn mô hình AI: <strong>GPT-4o-mini</strong> (nhanh, 5 lần/phút) hoặc <strong>GPT-4o</strong> (chính xác hơn, 1 lần/phút)</li>
                    <li>Nhập câu hỏi vào ô chat</li>
                    <li>AI sẽ trả lời chi tiết với công thức toán học (LaTeX), hình vẽ, và giải thích</li>
                </ol>
            </div>

            <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-lg border border-purple-200">
                <h3 className="text-lg font-semibold text-purple-900 mb-2">✨ Tính năng đặc biệt</h3>
                <ul className="text-slate-700 space-y-2">
                    <li>• <strong>Hiển thị công thức toán:</strong> AI render công thức toán học đẹp mắt với KaTeX</li>
                    <li>• <strong>Lưu lịch sử:</strong> Tất cả cuộc trò chuyện được lưu lại để bạn xem lại</li>
                    <li>• <strong>Nhiều phiên chat:</strong> Tạo nhiều phiên chat khác nhau cho từng chủ đề</li>
                    <li>• <strong>Giới hạn sử dụng hợp lý:</strong> Tránh spam và đảm bảo chất lượng phản hồi</li>
                </ul>
            </div>

            <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
                <h3 className="text-lg font-semibold text-blue-900 mb-2">💡 Mẹo sử dụng hiệu quả</h3>
                <ul className="text-slate-700 space-y-2">
                    <li>• Đặt câu hỏi rõ ràng, cụ thể</li>
                    <li>• Cung cấp đầy đủ thông tin bài toán (đề bài, dữ liệu...)</li>
                    <li>• Yêu cầu AI giải thích chi tiết nếu chưa hiểu</li>
                    <li>• Sử dụng GPT-4o-mini cho câu hỏi đơn giản, GPT-4o cho bài phức tạp</li>
                </ul>
            </div>
        </div>
    );
};

export default AISection;
